<div fxLayout="row" class="collaborator-bloc">
  <div fxLayout="column" fxFlex="86">
    {{ dataService.res('Ubt-CreateMeasureTask-Collaborators') }}
  </div>
  <div fxLayout="column" fxFlex="7">
    <abc-button
      [hoverStateEnabled]="false"
      [icon]="'assets/images/history.svg'"
      stylingMode="text"
      (onClick)="calculateOverallTime()"
      [width]="'100%'"
    ></abc-button>
  </div>
  <div fxLayout="column" fxFlex="7">
    <abc-button [icon]="'assets/images/plus.svg'" [stylingMode]="'text'"
    [disabled]="!canManageTasks" (onClick)="addCollaborator()"> </abc-button>
  </div>
</div>
<abc-grid
  #collaboratorGrid
  [id]="'collaboratorGrid'"
  [noDataText]="noDataText"
  class="grid-group-by-Style save-icon-style collaborator-grid"
  [height]="'150px'"
  [dataSource]="collaboratorsData"
  (onCellPrepared)="cellPrepared($event)"
  (onSaved)="saveCollaborator($event)"
  [columns]="measureService.collaboratorsColumns"
  (onRowRemoved)="removeCollaborator($event)"
>
  <dxo-group-panel #dxGroup [visible]="false"></dxo-group-panel>
  <dxo-column-chooser [enabled]="false"> </dxo-column-chooser>

  <dxo-export [enabled]="false"></dxo-export>
  <dxo-editing [mode]="'row'" [allowDeleting]="canManageTasks" [allowUpdating]="canManageTasks" [allowAdding]="false"> </dxo-editing>

  <dxo-filter-row [visible]="false"></dxo-filter-row>
  <dxo-filter-panel [visible]="false"></dxo-filter-panel>
  <dxo-search-panel [visible]="false"> </dxo-search-panel>

  <dxo-header-filter [visible]="false"></dxo-header-filter>
  <div *dxTemplate="let data of 'cellTemplate'">
    <a class="linkStyle"> {{ data['text'] }} </a>
  </div>
</abc-grid>
